import { Popup } from '@ui/src';
import { useAppSelector } from '@store';
import { ClientScoreTypeEnum } from '../../../../hoc/common/types';
import { ApplicationRiskScoreTypes } from './types';
import { ApplicationType } from '../../../../hoc/new-application/types';
import RiskScoreTop from './parts/risk-score-top';
import RiskScoreResults from './parts/risk-score-results';
import useRiskScore from './hooks/use-risk-score';

const ApplicationRiskScore = ({
  aml,
  type,
  isEditable,
  status,
  updateIsSuccess,
  requestInProgress,
  calculateAllowed,
  amlUpdateStatus,
  onUpdate,
  riskScoreIsLoading,
  manualScoreAllowed,
  users,
  changeLogsAvailable,
  setRiskScoreChangeLogsSidepanelVisible,
  setManualScoreSidepanelVisible,
}: ApplicationRiskScoreTypes) => {
  const {
    blockCollapsed,
    setBlockCollapsed,
    expanded,
    setExpanded,
    setPopupVisible,
    setRiskScoreMenuVisible,
    riskScoreMenuVisible,
    onExpandClick,
    expandedRows,
    setExpandedRows,
    popupVisible,
  } = useRiskScore({
    clientScoreType: aml?.clientScoreType,
    updateIsSuccess,
  });

  const {
    monthlyTurnover,
    riskScoreRanges,
    monthlyTurnoverCorporate,
    deliveryChannelsIndividual,
    deliveryChannelsCorporate,
    clientsActivities,
    productsCorporate,
    productsIndividual,
    sourcesOfFunds,
    sicCodesDictionaries,
  } = useAppSelector((state) => state.customersDictionaries);
  const { countriesList: countries } = useAppSelector((state) => state.root);

  const products =
    type === ApplicationType.INDIVIDUAL
      ? productsIndividual
      : productsCorporate;

  return (
    <>
      <RiskScoreTop
        blockCollapsed={blockCollapsed}
        riskScoreIsLoading={riskScoreIsLoading}
        aml={aml}
        status={status}
        requestInProgress={requestInProgress}
        setBlockCollapsed={setBlockCollapsed}
        expanded={expanded}
        setExpanded={setExpanded}
        riskScoreRanges={riskScoreRanges}
        users={users}
        amlUpdateStatus={amlUpdateStatus}
        manualScoreAllowed={manualScoreAllowed}
        setManualScoreSidepanelVisible={setManualScoreSidepanelVisible}
        calculateAllowed={calculateAllowed}
        setPopupVisible={setPopupVisible}
        changeLogsAvailable={changeLogsAvailable}
        setRiskScoreMenuVisible={setRiskScoreMenuVisible}
        riskScoreMenuVisible={riskScoreMenuVisible}
        setRiskScoreChangeLogsSidepanelVisible={
          setRiskScoreChangeLogsSidepanelVisible
        }
      />

      {blockCollapsed && (
        <RiskScoreResults
          onExpandClick={onExpandClick}
          expandedRows={expandedRows}
          setExpandedRows={setExpandedRows}
          aml={aml}
          riskScoreRanges={riskScoreRanges}
          type={type}
          countries={countries}
          isEditable={isEditable}
          clientsActivities={clientsActivities}
          deliveryChannelsCorporate={deliveryChannelsCorporate}
          deliveryChannelsIndividual={deliveryChannelsIndividual}
          products={products}
          sicCodesDictionaries={sicCodesDictionaries}
          sourcesOfFunds={sourcesOfFunds}
          monthlyTurnover={monthlyTurnover}
          monthlyTurnoverCorporate={monthlyTurnoverCorporate}
        />
      )}
      <Popup
        title={
          aml?.clientScoreType === ClientScoreTypeEnum.MANUAL
            ? 'Customer Application Risk Score was set manually. The update will return Customer Risk Score to the automatically calculated values'
            : 'Customer application risk score will updated'
        }
        onCancelClick={() => setPopupVisible(false)}
        onOkClick={() => onUpdate && onUpdate()}
        cancelButtonText="Cancel"
        okButtonText={requestInProgress ? 'Loading...' : 'Update'}
        isVisible={popupVisible}
      />
    </>
  );
};

export default ApplicationRiskScore;
